// Components
import NavbarItems from "components/shared/Navbar/NavbarItems";

interface NavbarProps {
	isHeaderBurgerOpen: boolean;
	setIsHeaderBurgerOpen: (isHeaderBurgerOpen: boolean) => void;
	setIsProfileOpen: (isProfileOpen: boolean) => void;
	setIsCorporateHatOpen: (isCorporateHatOpen: boolean) => void;
	setCorpHatAccordionStates: (corpHatAccordionStates: boolean[]) => void;
	htmlHeaderClientSide: string;
}

const Navbar = ({isHeaderBurgerOpen, setIsHeaderBurgerOpen, setIsProfileOpen, setIsCorporateHatOpen, setCorpHatAccordionStates, htmlHeaderClientSide }: NavbarProps) => {
	const handleProfileOpen = () => {
		setIsHeaderBurgerOpen(false);
		setIsProfileOpen(true);
	};
	return (
		<nav className="wk-navbar" role="navigation">
			<div className={`wk-navbar-container ${isHeaderBurgerOpen ? "wk-open" : ""}`}>
				<div className="wk-navbar-nav-container">
					<span className="wk-mobile-profile" onClick={handleProfileOpen}>
						<div className="wk-profile-user">
							<span className="wk-icon-user-check"/>
							<div className="wk-item-profile-label">PROFILO</div>
						</div>
						<span className="wk-icon-arrow-right wk-bg-icon"/>
					</span>
					<NavbarItems setIsCorporateHatOpen={setIsCorporateHatOpen} setCorpHatAccordionStates={setCorpHatAccordionStates} htmlHeaderClientSide={htmlHeaderClientSide}/>
				</div>
			</div>
		</nav>
	);
};

export default Navbar;
